export default __webpack_public_path__ + "static/media/closeicon--black.ea737184.svg";